// extracted by mini-css-extract-plugin
export var noSpinners = "_ok-6";
export var percentageInput = "_ok-7";
export var variantColor1 = "_ok-0";
export var variantColor2 = "_ok-1";
export var variantColor3 = "_ok-2";
export var variantColor4 = "_ok-3";
export var variantColor5 = "_ok-4";
export var variantColor6 = "_ok-5";